module.exports = __webpack_public_path__ + "img/img4.436d8cc1.jpg";